/**
 * Track events via Google analytics
 *
 * @param cat string Event category
 * @param act string Event action
 * @param lab string Event label
 * @param val string Event value
 * @param evloc string Custom dimension clickLocation
 */
 export function hbdTrackEvent(cat, act, lab, val, evloc) {
    var eventObj = {
        'Kategorie': cat,
        'Action': act,
        'event': 'genericEvent'
    };

    if (lab) {
        eventObj['Label'] = lab;
    }

    if (val) {
        eventObj['Wert'] = val;
    }

    if (evloc) {
        eventObj['clickLocation'] = evloc;
    }

    dataLayer.push(eventObj);
}